module.exports = __webpack_public_path__ + "static/media/phone.9bd68c8f.svg";